export default __webpack_public_path__ + "static/media/cover2.eeee6e53.jpg";